import { SVGProps } from 'react'

export const FieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="13.125"
      height="3.75"
      rx="1.875"
      fill="#A4A4A4"
    />
    <rect
      x="0.5"
      y="7.58325"
      width="25"
      height="3.75"
      rx="1.875"
      fill="#A4A4A4"
    />
    <rect
      x="0.5"
      y="14.6667"
      width="21.25"
      height="3.75"
      rx="1.875"
      fill="white"
    />
    <rect
      x="0.5"
      y="21.75"
      width="18.125"
      height="3.75"
      rx="1.875"
      fill="#A4A4A4"
    />
  </svg>
)
